/**
 * ネットワーク通信が失敗したことを示すエラー。
 *
 * 再認証要求とは区別され、UI 層ではネットワークエラー通知を表示し
 * 進行中の業務操作をキャンセルする。
 */
export class NetworkError extends Error {
    constructor(message: string = "Network error") {
        super(message);
        this.name = "NetworkError";
    }
}
